<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item prop="title">
                <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.活动标题')}}<template slot="title">{{$t('投票排行榜活动管理.活动标题')}}</template></a-tooltip> </span>
                <a-input v-model="queryParam.title" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('投票排行榜活动管理.活动标题')" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
<!--              <a-col :md="6" :sm="24">-->
<!--                <a-form-item prop="sort">-->
<!--                  <span slot="label" ><a-tooltip>{{$t('投票排行榜活动管理.排序')}}<template slot="title">{{$t('投票排行榜活动管理.排序')}}</template></a-tooltip> </span>-->
<!--                  <a-input v-model="queryParam.sort" :maxLength="32" :placeholder="$t('通用.输入.请输入')+'排序'" allow-clear @pressEnter="handleQuery"/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('通用.文本.创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('通用.文本.创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['zb:huodong:add']">
          <a-icon type="plus" />{{$t('投票排行榜活动管理.新增活动')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['zb:huodong:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['zb:huodong:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['zb:huodong:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 活动奖励商品 -->
      <huodong-goods
        ref="huodongGoods"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
<!--        <span slot="status" slot-scope="text, record">-->
<!--                <a-switch-->
<!--                  checked-children="开"-->
<!--                  un-checked-children="关"-->
<!--                  :checked="!record.status"-->
<!--                  @change="confirmHandleStatus(record)"-->
<!--                />-->
<!--          </span>-->
        <span slot="startTime" slot-scope="text, record">
          {{ parseTime(record.startTime) }}
        </span>
        <span slot="endTime" slot-scope="text, record">
          {{ parseTime(record.endTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="newStatus" slot-scope="text, record">
           <custom-dict-tag :options="customDict.HuodongStatusEnum" :value="record.newStatus"/>
        </span>
        <template slot="coverImg" slot-scope="text, record">
          <div>
            <img v-if="record.coverImg" :src="record.coverImg"  style="width:60px;height:62px;" @click="handleRecordPreview(record.coverImg)" alt="none"/>
          </div>
        </template>
        <template slot="picture" slot-scope="text, record">
          <div>
            <img v-if="record.picture" :src="record.picture"  style="width:60px;height:62px;" @click="handleRecordPreview(record.picture)" alt="none"/>
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['zb:huodong:goods']" />
          <a @click="$refs.huodongGoods.show(record)" v-hasPermi="['zb:huodong:goods']">
            <a-icon type="shopping" />{{$t('投票排行榜活动管理.投票商品')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['zb:huodong:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['zb:huodong:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['zb:huodong:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['zb:huodong:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageHuodong,listHuodong,changeStatus, delHuodong } from '@/api/huodong/huodong'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/TCreateForm'
import { tableMixin } from '@/store/table-mixin'
import {changeUserStatus} from "@/api/system/user";
import HuodongGoods from './thuodongGoods'

export default {
  name: 'Huodong',
  components: {
    CustomDictTag,
    HuodongGoods,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        title: undefined,
        coverImg: undefined,
        picture: undefined,
        introduction: undefined,
        type: 2,
        content: undefined,
        startTime: undefined,
        endTime: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('通用.文本.编号'),
        //   dataIndex: 'id',
        //   align: 'center'
        // },
        {
          title: this.$t('投票排行榜活动管理.活动标题'),
          dataIndex: 'title',
          align: 'center'
        },
        {
          title: this.$t('投票排行榜活动管理.封面图'),
          scopedSlots: { customRender: 'coverImg' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('投票排行榜活动管理.活动顶部图片'),
        //   scopedSlots: { customRender: 'picture' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: this.$t('投票排行榜活动管理.简介'),
          dataIndex: 'introduction',
          align: 'center'
        },
        // {
        //   title: this.$t('投票排行榜活动管理.类型'),
        //   dataIndex: 'type',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('投票排行榜活动管理.活动规则'),
        //   dataIndex: 'content',
        //   align: 'center'
        // },
        {
          title: this.$t('投票排行榜活动管理.活动开始时间'),
          dataIndex: 'startTime',
          align: 'center'
        },
        {
          title: this.$t('投票排行榜活动管理.活动结束时间'),
          dataIndex: 'endTime',
          align: 'center'
        }, /*{
          title: '状态',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },*/
        {
          title: '状态',
          dataIndex: 'newStatus',
          scopedSlots: { customRender: 'newStatus' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: this.$t('投票排行榜活动管理.排序'),
        //   dataIndex: 'sort',
        //   align: 'center'
        // },
        {
          title: this.$t('投票排行榜活动管理.前几名商品中奖'),
          dataIndex: 'zhongjiang',
          align: 'center'
        },
        {
          title: this.$t('投票排行榜活动管理.创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    /** 显示弹窗方法 */
    show(record) {
      console.log('显示商品管理弹窗:', record)
      this.currentHuodong = record
      this.queryParam.huodongId = this.currentHuodong.id
      console.log('显示活动id:', this.currentHuodong.id)
      this.open = true
      // 加载商品数据
      this.getList()
    },
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询投票排行榜活动管理列表 */
    getList () {
      this.loading = true
      pageHuodong(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },



    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        title: undefined,
        coverImg: undefined,
        picture: undefined,
        introduction: undefined,
        type: 2,
        content: undefined,
        startTime: undefined,
        endTime: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    /* 用户状态修改 status 0开启 1关闭*/
    confirmHandleStatus(row) {
      const oldStatus = row.status
      const text = row.status ? '关闭' : '开启'
      const status = row.status ? false : true
      changeStatus(row.id, status).then((res) => {
        if (res.success) {
          row.status = status
          //this.$message.success(text + '成功', 3)
        }else{
          row.status = oldStatus
          //this.$message.error(`${text}失败, ${res.message}`, 3)
        }
      }).catch(() => {
        this.$message.error(text + '异常', 3)
      })
    },

    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          return delHuodong(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(message,3)
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('zb/huodong/export',
            that.queryParam
            , `投票排行榜活动管理_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
